// src/components/practice/MultipleChoiceQuestion.jsx
import React from 'react';
// import { Check, X } from 'lucide-react'; // REMOVED

/**
 * REDESIGNED: Paper Exam Style
 * This component renders only the list of options for a multiple-choice question.
 * The styling is updated to match the black-and-white paper theme.
 */
const MultipleChoiceQuestion = ({ question, onAnswer, savedAnswer }) => {
  // showResult prop and logic are removed to align with paper-style interaction
  // (allowing answers to be changed).

  return (
    <div className="space-y-3">
      {question.options.map((option, index) => {
        const isSelected = savedAnswer === option.id;

        return (
          <button
            key={option.id}
            onClick={() => onAnswer(question.questionId, option.id)}
            // 'disabled' prop is removed to allow user to change their answer
            className={`
              w-full text-left p-4 rounded-none border-2 flex items-start justify-between transition-all
              ${isSelected
                ? 'border-gray-900 bg-gray-900 text-white' // Selected style
                : 'border-gray-400 bg-white text-gray-900 hover:border-gray-900' // Default style
              }
            `}
          >
            {/* This layout uses a text-based "a.", "b." label
              which is more paper-like.
            */}
            <span className={`font-semibold w-6 flex-shrink-0 ${isSelected ? 'text-white' : 'text-gray-900'}`}>
              {String.fromCharCode(97 + index)}.
            </span>
            <span className={`flex-1 ${isSelected ? 'text-white' : 'text-gray-900'}`}>
              {option.text}
            </span>
            {/* Removed Check/X icons */}
          </button>
        );
      })}
    </div>
  );
};

export default MultipleChoiceQuestion;